'use client';

import { BigNum, QUOTE_PRECISION_EXP } from '@drift-labs/sdk';
import { useAllVaultStats } from 'src/hooks/query/vaults/derived/useVaultStats';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import ValueWithLabelCard from '../primitives/ValueWithLabelCard/ValueWithLabelCard';
import NumberDisplay from '../NumberDisplay/NumberDisplay';

export const VaultsTotalStat = () => {
	const { data, isLoading } = useAllVaultStats();
	const vaultsStatsList = data.list;
	const areInitialVaultsStatsLoaded = !isLoading && vaultsStatsList.length > 0;

	const tvl = !areInitialVaultsStatsLoaded
		? BigNum.from(0, QUOTE_PRECISION_EXP)
		: vaultsStatsList.reduce(
				(acc, curr) => {
					return acc.add(curr.tvlQuote);
				},
				BigNum.from(0, QUOTE_PRECISION_EXP)
			);

	const totalPnl = !areInitialVaultsStatsLoaded
		? BigNum.from(0, QUOTE_PRECISION_EXP)
		: vaultsStatsList.reduce(
				(acc, curr) => {
					return acc.add(curr.totalQuotePnl);
				},
				BigNum.from(0, QUOTE_PRECISION_EXP)
			);

	return (
		<ValueWithLabelCard.Container className="w-[332px] justify-between">
			<ValueWithLabelCard.Item label="Total Value Locked">
				{!areInitialVaultsStatsLoaded ? (
					<SkeletonValuePlaceholder loading className="h-6 w-12" />
				) : (
					<NumberDisplay
						value={tvl}
						type="currency"
						millify={{ decimals: 2 }}
					/>
				)}
			</ValueWithLabelCard.Item>
			<ValueWithLabelCard.Item label="Total P&L">
				{!areInitialVaultsStatsLoaded ? (
					<SkeletonValuePlaceholder loading className="h-6 w-12" />
				) : (
					<NumberDisplay
						value={totalPnl}
						type="currency"
						millify={{ decimals: 2 }}
						trimZeroes
					/>
				)}
			</ValueWithLabelCard.Item>
		</ValueWithLabelCard.Container>
	);
};
